import { createStyles, makeStyles } from "@material-ui/core";

const defaultGlobalStyle = makeStyles((theme) =>
  createStyles({
    "@global": {
      ".w250": {
        width: 250,
      },
      ".float-right": {
        float: "right",
      },
      ".cursor-pointer": {
        cursor: "pointer !important",
      },
      ".cursor-default": {
        cursor: "default",
      },
      ".lineHeight-18": {
        lineHeight: "18px",
      },
      ".w-100": {
        width: "100%",
      },
      ".mb4": {
        marginBottom: "4px !important",
      },
      ".mb10": {
        marginBottom: "10px !important",
      },
      ".m0": {
        margin: 0,
      },
      ".p0": {
        padding: "0 !important",
      },
      ".p38": {
        paddingLeft: 38,
        paddingRight: 38,
      },
      ".px-50": {
        paddingLeft: 50,
        paddingRight: 50,
      },
      ".pr-70": {
        paddingRight: 70,
      },
      ".pl-70": {
        paddingLeft: 70,
      },
      ".pl-50": {
        paddingLeft: 50,
      },
      ".pl-32": {
        paddingLeft: 32,
      },
      ".mt5": {
        marginTop: 5,
      },
      ".mt15": {
        marginTop: 15,
      },
      ".mr5": {
        marginRight: 5,
      },
      ".mr10": {
        marginRight: 10,
      },
      ".mr15": {
        marginRight: 15,
      },
      ".mr20": {
        marginRight: 20,
      },
      ".mb2": {
        marginBottom: 2,
      },
      ".mb5": {
        marginBottom: 5,
      },
      ".mb8": {
        marginBottom: 8,
      },
      ".mb15": {
        marginBottom: 15,
      },
      ".ml10": {
        marginLeft: 10,
      },
      ".ml15": {
        marginLeft: 15,
      },
      ".ml5": {
        marginLeft: "5px !important",
      },
      ".ml2": {
        marginLeft: "2px !important",
      },
      ".v-middle": {
        verticalAlign: "middle",
      },
      ".float-right": {
        float: "right",
      },
      ".text-shadow": {
        textShadow: "0px 3px 6px #00000029",
      },
      ".text-primary": {
        color: "#08519C !important",
      },
      ".text-error": {
        color: "red",
      },
      ".text-success": {
        color: "green",
      },
      ".f-light-gray": {
        color: "#A0A0A0 !important",
      },
      ".f-italic": {
        fontStyle: "italic",
      },
      ".normal-txt": {
        fontStyle: "normal",
      },
      ".nofi-gray": {
        color: "#5E6066",
      },
      ".nofi-date-gray": {
        color: "#5E6066",
      },
      ".f-gray": {
        color: "#596268 !important",
      },
      ".f-black": {
        color: "#202f43",
      },
      ".f-black-new": {
        color: "#283941",
      },
      ".font-11": {
        fontSize: "11px !important",
      },
      ".font-12": {
        fontSize: "12px !important",
      },
      ".font-13": {
        fontSize: "13px !important",
      },
      ".font-14": {
        fontSize: "14px !important",
      },
      ".font-15": {
        fontSize: "15px !important",
      },
      ".font-16": {
        fontSize: "16px !important",
      },
      ".font-18": {
        fontSize: "18px !important",
      },
      ".font-20": {
        fontSize: "20px",
        [theme.breakpoints.down("xs")]: {
          fontSize: 16,
        },
      },
      ".font-light": {
        fontWeight: "200",
      },
      ".font-regular": {
        fontWeight: "400 !important",
      },
      ".font-semibold": {
        fontWeight: "500",
      },
      ".font-bold": {
        fontWeight: "600",
      },
      ".text-italic": {
        fontStyle: "italic",
      },
      b: {
        fontWeight: "600",
      },
      ".break-word": {
        wordBreak: "break-word",
      },
      ".border-primary": {
        borderColor: "#08519C2B",
      },
      ".d-flex": {
        display: "flex",
      },
      ".d-block": {
        display: "block",
      },
      ".d-inline": {
        display: "inline !important",
      },
      ".d-block-xs": {
        [theme.breakpoints.down("xs")]: {
          display: "block",
        },
      },
      ".padding-0": {
        padding: 0,
      },
      ".border": {
        border: "1px solid #EDEDED",
      },
      ".rounded": {
        borderRadius: 8,
      },
      ".bg-light": {
        background: "#FAFAFA",
      },
      ".link": {
        textDecoration: "none",
        color: theme.palette.primary.main,
        fontWeight: 500,
      },
      ".truncate-txt": {
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis",
      },
      ".color-success": {
        color: "#169D6B",
      },
      ".color-error": {
        color: "#F84E4E",
      },
      ".color-error-light": {
        color: "#FF7575",
      },
      ".muted-btn": {
        background: "#F2F7FC",
        color: "#94A3B3",
        fontSize: 13,
        boxShadow: "0px 1px 2px #B9BCC05E",
        padding: "4px 30px",
        borderRadius: 30,
      },
      ".btn-small": {
        height: 26,
        borderRadius: 8,
      },
      ".custom-btn": {
        boxShadow: "0px 1px 2px #B9BCC05E",
        border: "1px solid #d8ecff",
        color: "#07519C",
        fontSize: 14,
        fontWeight: 500,
        padding: "6px 16px",
        borderRadius: 8,
        background: "#fff",
      },
      ".custom-btn-small": {
        boxShadow: "0px 1px 2px #B9BCC05E",
        border: "1px solid #d8ecff",
        color: "#07519C",
        fontSize: 13,
        fontWeight: 500,
        padding: "2px 12px",
        background: "#fff",
      },
      ".MuiButton-outlined": {
        border: "1px solid #EDEDED",
      },
      ".MuiButtonBase-root": {
        borderRadius: 8,
      },
      ".MuiIconButton-root": {
        borderRadius: "50%",
      },
      ".rotate-icon": {
        transform: "rotate(-45deg)",
      },
      ".rotate-icon-reverse": {
        transform: "rotate(45deg)",
      },
      ".MuiBackdrop-root": {
        background: "#181E24BF",
      },
      ".Mui-selected img": {
        filter:
          "invert(27%) sepia(51%) saturate(2878%) hue-rotate(346deg) brightness(104%) contrast(97%) !important",
      },
      ".MuiInput-underline": {
        "&:before": {
          borderBottom: "solid 1px #CBCBCB",
        },
      },
      ".MuiInput-underline:hover:not(.Mui-disabled):before": {
        borderBottom: "1px solid #000",
      },
      ".MuiCheckbox-root": {
        color: "#C9CACD !important",
      },
      ".MuiCheckbox-root.Mui-checked": {
        color: "#004177 !important",
      },
      // kendo theming changes
      ".kendo-btn": {
        textAlign: "left",
        lineHeight: "13px",
        fontSize: 13,
        height: 32,
      },
      ".kendo-btn img": {
        minWidth: 18,
        width: 18,
      },
      ".kendo-btn .MuiTypography-root": {
        width: 82,
      },
      ".k-dropdown .k-dropdown-wrap.k-state-focused": {
        borderBottomColor: theme.palette.secondary.dark,
        borderBottom: "1.5px solid",
      },
      ".k-multicheck-wrap": {
        overflowX: "unset",
        whiteSpace: "unset",
        "& .k-item": {
          "& span": {
            display: "flex",
          },
        },
      },
      ".k-filter-selected-items": {
        fontSize: 14,
        fontWeight: 500,
      },
      ".k-animation-container .k-columnmenu-item": {
        fontSize: 12,
      },
      ".k-animation-container": {
        "& button": {
          "&.k-primary": {
            background: theme.palette.primary.main,
          },
        },
        "& .k-columnmenu-item": {
          fontSize: 14,
        },
        "& .k-input": {
          fontSize: "14px !important",
        },
      },
      // kendo theming changes end
      ".dot-indicator": {
        height: 8,
        width: 8,
        minWidth: 8,
        borderRadius: "50%",
        display: "inline-block",
        marginRight: 5,
        verticalAlign: "middle",
        marginTop: -2,
      },
      ".pending-indicator": {
        background: "#EF7713",
      },
      ".active-indicator": {
        background: "#009C55",
      },
      ".deactivated-indicator": {
        background: "#A1A1A1",
      },
      ".reactivated-indicator": {
        background: "#7F461B",
      },
      ".completed-indicator": {
        background: "#009C55",
      },
      ".overdue-indicator": {
        background: "#F34113",
      },
      ".new-indicator": {
        background: "#FCBE2D",
      },
      // for global searchbar
      ".MuiAutocomplete-option": {
        fontSize: 13,
      },
      ".avatar-img": {
        width: 36,
        height: 36,
        marginRight: 10,
        fontWeight: "normal",
        fontSize: 16,
        "& img": {
          width: "100%",
          objectFit: "cover",
          height: "100%",
        },
      },
      ".avatar-bg": {
        background: "#FFDBBD !important",
        color: "#BA8A62 !important",
      },
      ".MuiFormLabel-root.Mui-error": {
        color: "#202f43",
      },
      ".MuiPaper-root": {
        color: "#202f43",
      },
      ".MuiDialog-paper": {
        borderRadius: 10,
        "@media(max-width: 599.95px)": {
          borderRadius: 0,
        },
      },
      ".MuiAutocomplete-popper": {
        zIndex: "99999 !important",
        "& .MuiPaper-root": {
          boxShadow: "0 0px 4px 1px rgb(0 0 0 / 14%)",
        },
      },
      ".MuiPickersDay-root.Mui-selected": {
        backgroundColor: "#07519C !important",
      },
      ".MuiMenuItem-root": {
        fontSize: 13,
      },
      ".MuiButton-outlinedPrimary": {
        background: "#fff",
      },
      ".MuiFormLabel-asterisk": {
        color: "#db3131",
      },
      ".MuiInputLabel-asterisk": {
        color: "#FF6D6D",
        marginLeft: 3,
      },
      ".MuiAutocomplete-listbox": {
        padding: "0 !important",
      },
      ".MuiAutocomplete-option": {
        background: "#fff !important",
        padding: 0,
      },
      ".MuiSnackbar-root": {
        zIndex: "9999 !important",
      },
      ".MuiDialog-root": {
        zIndex: "99999 !important",
      },
      ".MuiCardContent-root:last-child": {
        paddingBottom: 24,
      },
      ".MuiInput-underline.Mui-disabled:before": {
        borderBottomStyle: "solid",
      },
      ".alice-carousel__stage-item.__active.__target": {
        "& .thumb": {
          "& img": {
            border: "solid 1px",
            borderColor: theme.palette.secondary.main,
          },
        },
      },
      ".alice-carousel__dots": {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      },
      ".alice-carousel__dots-item:not(.__custom)": {
        width: 6,
        height: 6,
        marginRight: "10px !important",
      },
      ".alice-carousel__dots-item:not(.__custom).__active": {
        backgroundColor: "#EF7713 !important",
        width: "10px !important",
        height: "10px !important",
      },
      ".alice-carousel__dots-item:not(.__custom):hover": {
        backgroundColor: "#EF7713 !important",
      },
      ".grid-disabled-row": {
        background: "#eee",
        pointerEvents: "none",
        opacity: 0.5,
      },
      ".grid-disabled-row:hover": {
        background: "#eee !important",
        opacity: "0.5 !important",
      },
      ".pre-wrap": {
        whiteSpace: "pre-wrap",
      },
      ".multi-wrap-1": {
        display: "-webkit-box",
        overflow: "hidden",
        "-webkit-box-orient": "vertical",
        "-webkit-line-clamp": 1,
      },
      ".multi-wrap-2": {
        display: "-webkit-box",
        overflow: "hidden",
        "-webkit-box-orient": "vertical",
        "-webkit-line-clamp": 2,
      },
      ".multi-wrap-3": {
        display: "-webkit-box",
        overflow: "hidden",
        "-webkit-box-orient": "vertical",
        "-webkit-line-clamp": 3,
      },
      ".multi-wrap-4": {
        display: "-webkit-box",
        overflow: "hidden",
        "-webkit-box-orient": "vertical",
        "-webkit-line-clamp": 4,
      },
      ".multi-wrap-5": {
        display: "-webkit-box",
        overflow: "hidden",
        "-webkit-box-orient": "vertical",
        "-webkit-line-clamp": 5,
      },
      ".MuiTooltip-popper": {
        zIndex: 999999,
      },
      ".MuiTooltip-tooltip": {
        background: "#EEEEEE",
        border: "solid 1px #D1D1D1",
        color: "#1D1C1C",
        boxShadow: "0px 1px 4px #0000001C",
        "& *": {
          background: "none !important",
          color: "#1D1C1C !important",
          margin: 0,
          padding: 0,
          fontFamily: "inherit !important",
          whiteSpace: "pre-wrap",
        },
      },
      ".k-chart-tooltip-wrapper": {
        width: "auto !important",
        border: "solid 1px #D1D1D1",
        borderRadius: 4,
        boxShadow: "0px 1px 4px #0000001C",
        "& .k-chart-tooltip": {
          fontSize: "12px !important",
          color: "#1D1C1C",
          padding: "2px 4px",
        },
      },
      ".format-txt": {
        "& *": {
          background: "none !important",
          color: "inherit !important",
          fontSize: "inherit !important",
          fontFamily: "inherit !important",
        },
        "& ul": {
          listStyleType: "disc",
        },
        "& p": {
          overflow: "hidden",
          lineHeight: "1.3rem !important",
        },
      },
      ".format-color": {
        "& *:not(a)": {
          background: "none !important",
          color: "inherit !important",
        },
      },
      ".body-scroll-lock": {
        overflow: "hidden",
      },
      ".MuiButton-root.Mui-disabled": {
        opacity: 0.5,
      },
      ".MuiTabs-root": {
        minHeight: "35px !important",
        "& button": {
          minHeight: 35,
        },
      },
      ".MuiPopover-root": {
        zIndex: "99999 !important",
        "& .MuiListItem-root.Mui-selected": {
          background: "none",
          color: theme.palette.secondary.main,
        },
        "& .MuiPopover-paper": {
          maxHeight: "80%",
        },
      },
      ".gifImg": {
        width: 150,
        marginBottom: 16,
        "@media(max-width: 1024px)": {
          maxWidth: "100%",
        },
      },
      ".errorMessages": {
        color: "#F36F6F",
        fontSize: 14,
        marginTop: 3,
        display: "flex",
        "& svg": {
          fontSize: 18,
        },
      },
      ".MuiPickersToolbar-toolbar": {
        height: 80,
        "& .MuiTypography-h4": {
          fontSize: 20,
        },
      },
      ".MuiAutocomplete-listbox": {
        "& .MuiAutocomplete-option": {
          fontSize: 14,
          padding: "8px 16px",
          "&:hover": {
            background: "#eee !important",
          },
        },
        "& .MuiListSubheader-root": {
          lineHeight: "36px",
          color: "#000",
        },
      },
      ".MuiAutocomplete-option[data-focus='true']": {
        background: "rgba(0, 0, 0, 0.04) !important",
      },
      ".MuiOutlinedInput-colorSecondary.Mui-focused .MuiOutlinedInput-notchedOutline, .MuiOutlinedInput-root:focus":
        {
          border: "solid 1px #F3994E",
          boxShadow: "0px 1px 6px #FFD47099",
        },
      ".MuiOutlinedInput-root.Mui-disabled .MuiOutlinedInput-notchedOutline": {
        borderColor: "#EDEDED",
      },
      ".MuiInput-colorSecondary.MuiInput-underline:after": {
        borderBottom: "solid 1px #F3994E",
        boxShadow: "0px 1px 6px #FFD47099",
      },
      ".k-editor": {
        border: "solid 1px #EDEDED",
        borderRadius: 4,
        fontFamily: "inherit",
      },
      ".k-editor:has(.ProseMirror-focused)": {
        border: "solid 1px #F3994E",
        boxShadow: "0px 1px 6px #FFD47099",
      },
      ".k-editor-content": {
        wordBreak: "break-word",
      },
      ".k-editor-content > .ProseMirror": {
        padding: "0 14px 14px",
      },
      ".k-dialog-wrapper": {
        zIndex: "99999 !important",
      },
      ".k-toolbar .k-button": {
        marginRight: 2,
      },
      ".k-button-group .k-state-active": {
        background: "#FC7303 !important",
        color: "#fff",
      },
      ".k-editor > .k-toolbar": {
        boxShadow: "none",
        background: "none",
      },
      ".k-editor > .k-toolbar .k-button": {
        width: 30,
        height: 30,
        border: "#F0F2F6 solid 1px",
        background: "none",
      },
      ".k-editor iframe body": {
        padding: "8px 14px",
      },
      ".k-button-group .k-button.k-state-active": {
        zIndex: "unset",
      },
      ".btn-default": {
        background: "#fff",
        "&:hover": {
          background: "rgb(255 255 255 / 71%)",
        },
      },
      ".btn-success": {
        borderColor: "#4caf50",
        color: "#4caf50",
        background: "#fff",
      },
      ".btn-error": {
        borderColor: "#f44336",
        color: "#f44336",
        background: "#fff",
      },
      ".btn-primary": {
        borderColor: theme.palette.primary.main,
        color: theme.palette.primary.main,
        background: "#fff",
      },
      ".MuiCard-root": {
        borderRadius: 10,
        boxShadow: "0px 1px 6px #00000017",
      },
      ".MuiInputBase-input": {
        fontSize: 14,
      },
      ".MuiInputBase-input.Mui-disabled, .MuiInputBase-root.Mui-disabled": {
        background: "#FAFAFA",
      },
      ".MuiCalendarPicker-root": {
        "& .PrivatePickersSlideTransition-root": {
          minHeight: 240,
        },
      },
      ".MuiDialogActions-root": {
        justifyContent: "center !important",
      },
      ".checkbox-icon": {
        width: 20,
        height: 20,
      },
      ".checkbox-checked-icon": {
        width: 20,
        height: 20,
      },
      ".text-center": {
        textAlign: "center !important",
      },

      // custom container sizes
      ".MuiContainer-maxWidthLg": {
        maxWidth: "1326px !important",
        "@media(max-width: 1530px)": {
          maxWidth: "1326px !important",
        },
        "@media(max-width: 1366px)": {
          maxWidth: "1156px !important",
        },
        "@media(max-width: 1024px)": {
          maxWidth: "844px !important",
        },
      },
      ".MuiContainer-maxWidthMd": {
        maxWidth: "1058px !important",
        "@media(max-width: 1366px)": {
          maxWidth: "865px !important",
        },
      },
      "text-darkgray": {
        color: "#283941",
      },
      ".MuiInputBase-root.Mui-disabled": {
        "& .MuiIconButton-root.Mui-disabled": {
          color: "rgba(0, 0, 0, 0.26) !important",
        },
      },
      ".Mui-disabled": {
        "& svg": {
          color: "rgba(0, 0, 0, 0.26)",
        },
      },
      ".simplebar-scrollbar:before": {
        background: "rgba(0, 0, 0, 0.2) !important",
      },
      ".simplebar-scrollbar.simplebar-visible:before": {
        opacity: "1 !important",
      },
      ".simplebar-track.simplebar-vertical": {
        width: "10px !important",
        zIndex: "unset",
      },
      ".formatted-text": {
        "& p": {
          margin: 0,
        },
      },
      ".font-inherit": {
        fontFamily: "inherit",
      },
      ".position-static": {
        position: "static",
      },
      ".align-center": {
        alignItems: "center",
      },
      ".disable-arrow": {
        "& .k-hierarchy-cell": {
          "& .k-icon": {
            background: "#fff",
            border: "solid 1px #EFEFEF",
            cursor: "not-allowed",
            "&:before": {
              color: "#C9C9C9",
            },
          },
        },
      },
      ".disable-checkbox": {
        "& .k-checkbox": {
          pointerEvents: "none",
          background: "#F7F8F8",
          borderRadius: 4,
          border: "1px solid #E6E6E6",
        },
      },
      ".new-row-border": {
        "& td:first-child": {
          borderLeft: "solid 3px #EA954C !important",
        },
      },
      ".new-row-bg": {
        "& td": {
          //animation: 'bgAnimation 10s 1',
          background: "#FFF6EE !important",
        },
        "&:hover": {
          background: "#FFF6EE !important",
          "& td": {
            background: "none",
          },
        },
      },
      // "@keyframes bgAnimation": {
      //   "0%": {
      //     background: 'rgb(243 153 78 / 11%)'
      //   },
      //   "100%": {
      //     background: 'none'
      //   },
      // },
      ".MuiAvatar-colorDefault": {
        background: "#EEEEEE",
      },
      ".all-user-icon": {
        width: "24px !important",
        objectFit: "contain !important",
      },
      ".no-flex-xs": {
        "@media(max-width: 599.95px)": {
          display: "unset",
        },
      },
      ".PrivatePickersToolbar-dateTitleContainer": {
        display: "none !important",
      },
      ".drawer-open + .content-area": {
        width: "calc(100% - 260px)",
      },
      ".filter-primary": {
        filter:
          "brightness(0) saturate(100%) invert(17%) sepia(34%) saturate(7500%) hue-rotate(200deg) brightness(94%) contrast(95%)",
      },
      ".filter-white": {
        filter: "brightness(0) invert(1)",
      },
      ".position-relative": {
        position: "relative",
      },
      ".editor-error": {
        border: "solid 1px #f44336",
        borderRadius: 4,
      },
      ".MuiTypography-body2": {
        lineHeight: 1.3,
      },
      "& .select-menu-paper": {
        "& ul": {
          padding: 0,
        },
      },
    },
  })
);

export default defaultGlobalStyle;
